import { Component, Input } from '@angular/core';
import { TrademarkStatus } from 'src/app/models/trademark';
import { TrademarkService } from 'src/app/services/trademark.service';

@Component({
  selector: 'app-trademark-status',
  templateUrl: './trademark-status.component.html',
  styleUrls: ['./trademark-status.component.scss']
})
export class TrademarkStatusComponent {
  @Input() status?: string;

  constructor(
    private trademarkService: TrademarkService
  ) {

  }

  _status() {
    if (this.status) {
      const _mapped = this.trademarkService._statusMapper(this.status)
      return {
        isUnknown: _mapped.status === TrademarkStatus.UNKNOWN,
        status: _mapped.status !== TrademarkStatus.UNKNOWN ? _mapped.status : this.status,
        color: _mapped.color
      }
    }
    return {
      isUnknown: false,
      status: TrademarkStatus.UNKNOWN,
      color: "grey"
    }

  }
}
